import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {},
  isClear: false,
};

export const searchFilter = createSlice({
  name: "searchFilter",
  initialState,
  reducers: {
    setSearchFilter: (state, action) => {
      state.filters = action.payload;
    },
    resetSearchFilter: (state, action) => {
      state.filters = {
        ...initialState.filters,
        ...action.payload,
      };
      state.isClear = true;
    },
    setIsClear: (state, action) => {
      state.isClear = action.payload;
    },
  },
});

export const { setSearchFilter, resetSearchFilter, setIsClear } =
  searchFilter.actions;

export default searchFilter.reducer;
